// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1b3yV","item":"PaymentsMobile_item__2joHG","label":"PaymentsMobile_label__1AakU","amount":"PaymentsMobile_amount__22SYh"};